import { render, staticRenderFns } from "./SubNavItem.vue?vue&type=template&id=702ed1a6&scoped=true&"
import script from "./SubNavItem.vue?vue&type=script&lang=js&"
export * from "./SubNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SubNavItem.vue?vue&type=style&index=0&id=702ed1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ed1a6",
  null
  
)

export default component.exports